<template>
  <div class="above-footer hero is-medium">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-desktop is-variable is-8">
          <div class="contact column is-half-desktop">
              <form action="https://send.pageclip.co/ieseiFjwTFRKD5SireM9iSFePFvn9rkO" class="pageclip-form" method="post">
                <div class="input-text columns is-multiline is-tablet is-variable is-4">
                  <div class="subtitle column">Contact</div>
                </div>
                <div class="input-text columns is-multiline is-tablet is-variable is-4">
                  <div class="form-group column is-half">
                  <input name="First Name" type="text" placeholder="First Name*" v-model="firstName" class="form-control form__input input" required>
                </div>
                <div class="form-group column is-half">
                  <input name="Last Name" type="text" placeholder="Last Name*" v-model="lastName" class="form-control form__input input" required>
                </div>
                <div class="form-group column is-half">
                  <input name="email" type="email" placeholder="Email*" v-model="email" class="form-control form__input input" required>
                </div>
                <div class="form-group column is-half">
                  <select name="iAmA" id="I Am A" class="form-control form__input select is-fullwidth" required>
                    <option value="">I am a...*</option>
                    <option value="Customer">Customer</option>
                    <option value="Manufacturer">Manufacturer</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div class="form-group column is-full">
                  <input name="subject" type="text" placeholder="Subject" class="form__input input">
                </div>
                <div class="form-group column is-full">
                  <textarea rows="3" name="Message" type="textarea" placeholder="Message" id="message" class="form__input input"></textarea>
                </div>
              </div>
                <button type="submit" class="button is-uppercase pageclip-form__submit">
                  <span>Submit</span>
                </button>
              </form>
          </div>
          <div class="offices column is-half-desktop">
            <div class="columns is-desktop is-multiline">
              <div v-for="(location, index) in locations" :key="index" class="column is-half-desktop location">
                <div class="subtitle">{{ $prismic.richTextAsPlain(location.location_name) }}</div>
                <div class="address">
                  <div>{{ $prismic.richTextAsPlain(location.address_line_1) }}</div>
                  <div>{{ $prismic.richTextAsPlain(location.address_line_2) }}</div>
                </div>
                <br/>
                <div class="numbers">
                  <div>{{ $prismic.richTextAsPlain(location.phone) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pageclip from 'pageclip';
import ValidForm from '@pageclip/valid-form';

export default {
  name: 'AboveFooter',
  data () {
    return {
      formContent: [],
      dropdownOptions: [],
      errors: [],
      firstName: null,
      lastName: null,
      email: null,
      iAmA: null,
      subject: null,
      message: null,
      locations: {}
    }
  },
  methods: {
    camelCase: function(str) {
      if (str.includes("I am a")) {
        return "iAmA";
      }
      return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
        if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
        return index == 0 ? match.toLowerCase() : match.toUpperCase();
      });
    },
    getForm() {
      //Query to get menu content
      this.$prismic.client.getSingle('form')
        .then((document) => {
          if (document) {
            this.formContent = document.data;
            this.formContent.form_fields.forEach(field => {
              if (field.field_type === "Dropdown") {
                this.dropdownOptions = field.dropdown_options[0].text.split(',');
              }
            })
          }
        })
    },
    getLocations() {
      this.$prismic.client.getSingle('locations')
        .then((locationsContent) => {
          this.locations = locationsContent.data.locations;
        })
    }
  },
  created () {
    this.getForm();
    this.getLocations();
  },
  mounted () {
    var form = document.querySelector('.pageclip-form')
    window.Pageclip.form(form, {
      onSubmit: function (event) { },
      onResponse: function (error, response) { },
      successTemplate: '<span>Thank you for your submission!</span>'
    })

    const formElement = document.querySelector('form');
    ValidForm(formElement, {
      customMessages: {
        valueMissing: "This field is required.",
        patternMismatch: "Invalid input.",
        badInput: "Invalid input.",
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
@import "../assets/sass/colors.scss";

.contact {
  &.column {
    padding: 0;
  }
}

.offices {
  &.column {
    padding: 0 1.5rem;
  }
  .columns {
    height: 100%;
  }
}

.above-footer {
  background: $lightBlue;
  .columns.is-desktop.is-8 {
    margin: 0 auto;
    .contact {
      margin: 0 auto;
      .form-group {
        margin-bottom: 0;
        position: relative;
        .form__label {
          display: none;
        }
        .form__input {
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR…b4DHwIUAcWBjx5suSCCPyRlgG7WtvQj1P5o4kEfTK//fP8G/4x2UymA12DAAAAAElFTkSuQmCC);
          background-repeat: no-repeat;
          background-attachment: scroll;
          background-size: 16px 18px;
          background-position: 98% 50%;
          cursor: auto;
          font-family: "Open Sans", sans-serif;
          font-size: 0.875rem;
          font-weight: 400;
          color: $navy;
          line-height: 2.375rem;
          min-height: 3rem;
          position: relative;
          border: 1px solid $lightBlue;
          border-radius: 0px;
          background: $white;
          padding: 0 0.8125rem;
          width: 100%;
          transition: border 0.1s ease;
          box-sizing: border-box;
          outline: none;

          &:focus {
            border-color: #a8a8a8;
            outline: none;
          }
        }
        input {
          height: 35px;
          width: 100%;
        }
        textarea {
          height: auto;
          resize: none;
        }
      }
      
      
    }
    .offices {
      margin: 0 auto;
    }
  }
}
</style>
